<template>
  <div class="field-group">
    <span>{{ label }}</span>
    <input type="text" :value="value" @input="$emit('update', $event.target.value)" class="form-input" />
  </div>
</template>

<script>
export default {
  name: "AdGroupName",
  props: {
    value: { type: String, default: "" },
    label: { type: String, default: "Название Рекламной группы" }
  }
};
</script>